<template>
  <div class="sp-template">
    <div class="h-title">信用额度</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-button size="small" class="el-button" :class="[flag === 1 ? 'btn-cyan' : '']" @click="getCards(1)">我的卡包</el-button>
        <el-button size="small" class="el-button" v-if="customerCardsButton" :class="[flag === 2 ? 'btn-cyan' : '']" @click="getCards(2)">客户的卡包</el-button>
        <div v-if="customerCardsButton" class="balance">
          <span class="text">
            <b class="total">累计收款</b>共计：</span>
          <span class="number">
            <b>￥</b>{{balance}}</span>
        </div>
      </div>
      <!-- 我的卡包 -->
      <div class="my-card__content" v-if="flag === 1">
        <div slot="header" class="clearfix">
          <!-- <el-row>
            <el-col :span="8">
              <div class="show-balance">
                <span class="text">您当前账户的
                  <b class="total">信用额度</b>共计：</span>
                <span class="number">
                  <b>￥</b>{{totalCredit}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="show-balance">
                <span class="text">您当前账户的
                  <b class="total">可用余额</b>共计：</span>
                <span class="number">
                  <b>￥</b>{{totalCreditUseable}}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="show-balance">
                <a class="toggle-icon" href="#" @click.prevent="expandMyCards = !expandMyCards">
                  <span v-if="!expandMyCards">
                    <i class="el-icon-arrow-down"></i>展开全部卡片</span>
                  <span v-if="expandMyCards">
                    <i class="el-icon-arrow-up"></i>收起全部卡片</span>
                </a>
              </div>
            </el-col>
          </el-row> -->
          <!-- <el-row class="sp-card__row">
            <sp-card-group :cards=myCards :expand=expandMyCards :router=routerFlag[0].name></sp-card-group>
          </el-row> -->
          <el-table :data="myCards" show-summary :summary-method="getMySummaries" style="width: 100%">
            <el-table-column prop="providerOrgName" label="开卡方"></el-table-column>
            <el-table-column prop="orgOwnerName" label="持卡方"></el-table-column>
            <el-table-column prop="systemId" label="系统" :formatter="formatSystemName" width="160"></el-table-column>
            <el-table-column prop="paymentTermsName" label="结算周期" width="160"></el-table-column>
            <el-table-column prop="credit" label="信用额度" sortable></el-table-column>
            <el-table-column prop="creditUseable" label="可用额度" sortable></el-table-column>
            <el-table-column label="欠款" sortable>
              <template slot-scope="scope">
                <!-- <span v-if="scope.row.billDebt < 0" style="color: #f56c6c;">{{scope.row.billDebt}}</span> -->
                <span v-if="(scope.row.creditUseable - scope.row.credit) < 0" style="color: #f56c6c;">{{(scope.row.creditUseable - scope.row.credit).toFixed(2)}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="充值">
              <template slot-scope="scope">
                <router-link v-if="in_configs(202)" tag="el-button" plain size="small" class="el-button__small" :to="{path: '/recharge', query: {id: scope.row.id, providerOrgId: scope.row.providerOrgId, providerOrgName: scope.row.providerOrgName,
                  orgOwnerId: scope.row.orgOwnerId, orgOwnerName: scope.row.orgOwnerName, system: scope.row.systemId, credit: scope.row.credit, creditUseable: scope.row.creditUseable}}">在线充值</router-link>
                <router-link v-if="in_configs(202)" tag="el-button" plain size="small" class="el-button__small" :to="{path: '/deposit', query: {id: scope.row.id, providerOrgId: scope.row.providerOrgId, providerOrgName: scope.row.providerOrgName,
                  orgOwnerId: scope.row.orgOwnerId, orgOwnerName: scope.row.orgOwnerName, system: scope.row.systemId, credit: scope.row.credit, creditUseable: scope.row.creditUseable}}">线下充值</router-link>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalNums">
          </el-pagination>
        </div>
      </div>
      <!-- 客户的卡包 -->
      <div class="customer-card__content" v-if="flag === 2">
        <div slot="header" class="clearfix">
          <el-row class="sp-card__row">
            <el-form class="search-form" :inline="true" :model="conditions" size="small">
              <el-form-item label="持卡方">
                <el-select v-model="conditions.orgOwnerId" filterable clearable @change="search()" style="width: 300px;">
                  <el-option v-for="item in orgOwner" :key="item.id" :label="item.name" :value="item.id" palceholder="请选择持卡方">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="系统">
                <!-- clearable -->
                <el-select v-model="conditions.systemId" filterable  @change="search()" style="width: 300px;">
                  <el-option v-for="item in system" :key="item.id" :label="item.label" :value="item.id" palceholder="请选择系统">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button v-if="in_configs(201)" type="primary" plain @click="search()">搜索</el-button>
              </el-form-item>
              <!-- <el-form-item style="margin-left: 30px;">
                <div class="show-balance">
                  <a class="toggle-icon" href="#" @click.prevent="expandCustomerCards = !expandCustomerCards">
                    <span v-if = "!expandCustomerCards"><i class="el-icon-arrow-down"></i>展开全部卡片</span>
                    <span v-if = "expandCustomerCards"><i class="el-icon-arrow-up"></i>收起全部卡片</span>
                  </a>
                </div>
              </el-form-item> -->
            </el-form>
            <!-- <sp-card-group :cards=customerCards :expand=expandCustomerCards :router=routerFlag[1].name></sp-card-group> -->
            <el-table :data="customerCards" show-summary :summary-method="getCustomerSummaries" style="width: 100%">
              <el-table-column prop="providerOrgName" label="开卡方"></el-table-column>
              <el-table-column prop="orgOwnerName" label="持卡方"></el-table-column>
              <el-table-column prop="systemId" label="系统" :formatter="formatSystemName"></el-table-column>
              <el-table-column prop="paymentTermsName" label="结算周期"></el-table-column>
              <el-table-column prop="credit" label="信用额度" sortable></el-table-column>
              <el-table-column prop="creditUseable" label="可用额度" sortable></el-table-column>
              <el-table-column label="欠款" sortable>
                <template slot-scope="scope">
                  <!-- <span v-if="scope.row.billDebt < 0" style="color: #f56c6c;">{{scope.row.billDebt}}</span> -->
                  <span v-if="(scope.row.creditUseable - scope.row.credit) < 0" style="color: #f56c6c;">{{(scope.row.creditUseable - scope.row.credit).toFixed(2)}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="充值">
                <template slot-scope="scope">
                  <router-link v-if="in_configs(202)" tag="el-button" plain size="small" class="el-button__small" :to="{path: '/deposit', query: {id: scope.row.id, providerOrgId: scope.row.providerOrgId, providerOrgName: scope.row.providerOrgName,
                    orgOwnerId: scope.row.orgOwnerId, orgOwnerName: scope.row.orgOwnerName, system: scope.row.systemId, credit: scope.row.credit, creditUseable: scope.row.creditUseable}}">充值</router-link>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalNums">
            </el-pagination>
          </el-row>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getToken, setToken,removeToken } from '@/util/auth' // get token from cookie
import Card from "../../components/sp-card-group";

export default {
  data() {
    return {
      myCards: [],
      customerCards: [],
      conditions: { 
        orgOwnerId: "", 
        systemId: "TMS"
      },
      orgOwner: [],
      balance: "",
      system: [
        {
          id: "TMS",
          label: "TMS物流系统"
        },
        {
          id: "WMS",
          label: "WMS仓库系统"
        },
        {
          id: "PP",
          label: "小包物流系统"
        }
      ],
      recentBills: [
        {
          id: 123456789,
          info: "账户充值",
          currency: "人民币",
          amount: 2000.0,
          date: "2018-05-16 10：25"
        }
      ],
      routerFlag: [
        {
          name: "recharge",
          des: "针对我的卡包充值，跳转到recharge页面，可选择支付宝、微信充值"
        },
        {
          name: "deposit",
          des:
            "针对客户的卡包充值，跳转到deposit页面，可选择现金、支票等且要求上传凭证"
        }
      ],
      flag: 1,
      expandMyCards: false,
      expandCustomerCards: false,
      customerCardsButton: false,
      _totalCredit: 0,
      _totalCreditUseable: 0,
      _totalBillDebt: 0,
      totalNums: 0,
      currentPage: 1, //分页
      pageSize: 10
    };
  },
  components: {
    spCardGroup: Card
  },
  created() {

    // 用seller的token登录
    if (this.$route.query.sellerToken) {
      console.log(">>>this.$route.query.sellerToken111111", this.$route.query.sellerToken)
      setToken(this.$route.query.sellerToken)
      window.location.href = '/'

    }

    setTimeout(() => {
      this.queryAccount();
    }, 600);
  },
  computed: {
    totalCredit() {
      let totalCredit = 0;
      let cards = this.myCards;
      for (var i = 0; i < cards.length; i++) {
        totalCredit += cards[i].credit;
      }
      return totalCredit.toFixed(2);
    },
    totalCreditUseable() {
      let totalCreditUseable = 0;
      let cards = this.myCards;
      for (var i = 0; i < cards.length; i++) {
        totalCreditUseable += cards[i].creditUseable;
      }
      return totalCreditUseable.toFixed(2);
    }
  },
  methods: {
    // 表尾合计 --- 我的卡包
    getMySummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property === "credit") {
          sums[index] = this._totalCredit == null ? 0 : this._totalCredit.toFixed(2); // 这个值应该是后台计算好返回到前台的
        } else if (column.property === "creditUseable") {
          sums[index] = this._totalCreditUseable == null ? 0 : this._totalCreditUseable.toFixed(2);
        } else if (column.label === "欠款") {
          sums[index] = this._totalBillDebt == null ? 0 : this._totalBillDebt.toFixed(2);
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    // 表尾合计 --- 客户的卡包
    getCustomerSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property === "credit") {
          sums[index] = this._totalCredit == null ? 0 : this._totalCredit.toFixed(2); // 这个值应该是后台计算好返回到前台的
        } else if (column.property === "creditUseable") {
          sums[index] = this._totalCreditUseable == null ? 0 : this._totalCreditUseable.toFixed(2);
        } else if (column.label === "欠款") {
          sums[index] = this._totalBillDebt == null ? 0 : this._totalBillDebt.toFixed(2);
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    formatSystemName(row, column) {
      switch (row.systemId) {
        case "TMS":
          return "TMS物流系统";
          break;
        case "WMS":
          return "WMS仓库系统";
          break;
        case "PP":
          return "小包物流系统";
          break;
      }
    },
    queryAccount() {
      this.$request1({
        method: 'GET',
        url: '/account/query',
        params: {
          orgOwnerId: this.conditions.orgOwnerId,
          systemId: this.conditions.systemId,
          status: this.flag,
          currentPage: this.currentPage,
          pageSize: this.pageSize
        }
      })
        .then(response => {
          if(response.data.success){
            this.totalNums = response.data.total;
            this.customerCardsButton = response.data.data.customerCardsButton;
            this.balance = response.data.data.balance;
            this._totalCredit = response.data.data.totalCredit;
            this._totalCreditUseable = response.data.data.totalCreditUseable;
            this._totalBillDebt = response.data.data.totalBillDebt;
            if (this.flag == 1) {
              this.myCards = response.data.data.accountDtos;
            } else {
              this.customerCards = response.data.data.accountDtos;
            }

          }else{
            this.$message.error(response.data.message);
          }
          
        })
        .catch(error => {
          console.log(error);
        });
    },
    getCards(flag) {
      switch (flag) {
        case 1:
          this.flag = 1;
          break;
        case 2:
          this.flag = 2;
          this.orgOwner = [];
          this.$request1({
            method: 'GET',
            url: '/account/queryOrgOwner'
          })
            .then(response => {
              console.log(response.data);
              if (response.data.success) {
                this.orgOwner = response.data.data;
              } else {
                this.$message({
                  message: response.data.message,
                  type: error
                });
              }
            })
            .catch(error => {
              console.log(error);
            });
          break;
      }
      this.queryAccount();
    },
    search() {
      this.currentPage = 1;
      this.queryAccount();
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.queryAccount();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryAccount();
    }
  }
};
</script>

<style lang="scss" scoped>
.show-balance {
  height: 32px;
  line-height: 32px;
  .text {
    color: #969696;
    .total {
      margin: 0 5px;
      color: #3c8dbc;
      font-weight: 400;
    }
  }
  .number {
    color: #3c8dbc;
    font-size: 22px;
    font-weight: 700;
  }
}
.sub-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 1px solid #ebeef5;
  .recent-bills {
    color: #646464;
    font-size: 16px;
  }
  .show-all {
    color: #5694b8;
    font-size: 14px;
    &:hover {
      text-decoration: underline;
    }
  }
}
.toggle-icon {
  color: #409eff;
  > span {
    font-size: 12px;
    > i {
      margin-right: 5px;
      font-size: 14px;
    }
  }
}
.search-form {
  margin-bottom: 18px;
  border-bottom: 1px solid #ebeef5;
  > .el-form-item {
    margin-top: 18px;
  }
}

.balance {
  float: right;
  height: 32px;
  line-height: 32px;
  .text {
    color: #969696;
    .total {
      margin: 0 5px;
      color: #3c8dbc;
      font-weight: 400;
    }
  }
  .number {
    color: #3c8dbc;
    font-size: 22px;
    font-weight: 700;
  }
}
.el-button__small {
  padding: 9px 12px;
}
</style>


// WEBPACK FOOTER //
// src/views/balance/balance.vue